import { createAction } from '@reduxjs/toolkit';
import { AnonymousUserPermissions } from 'core/entities/user/anonymous-user-permissions';

export const setAnonymousUserPermissionsActionType = 'auth/set-anonymous-user-permissions';
export const setAnonymousUserPermissionsActionCreator = createAction<
    AnonymousUserPermissions,
    typeof setAnonymousUserPermissionsActionType
>(setAnonymousUserPermissionsActionType);
